var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-report-progress" }, [
    _c(
      "ol",
      {
        staticClass: "c-report-progress__list",
        attrs: { "aria-label": "Progress bar" }
      },
      [
        _c(
          "li",
          {
            staticClass:
              "c-report-progress__list-item c-report-progress__list-item--problem",
            class: _vm.stepState(1)
          },
          [
            _c("span", { staticClass: "c-report-progress__list-item-step" }, [
              _vm._v("Step 1")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "c-report-progress__list-item-label" }, [
              _vm._v(_vm._s(_vm.stepOneTitle))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "visually-hidden" }, [
              _vm._v(_vm._s(_vm.textState(1)))
            ]),
            _vm._v(" "),
            _vm.showTick(1)
              ? _c(
                  "svg",
                  {
                    staticClass: "c-report-progress__list-item-icon",
                    attrs: { "aria-hidden": "true", focusable: "false" }
                  },
                  [
                    _c("use", {
                      attrs: {
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xlink:href": "#tick"
                      }
                    })
                  ]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "c-report-progress__list-item c-report-progress__list-item--location",
            class: _vm.stepState(2)
          },
          [
            _c("span", { staticClass: "c-report-progress__list-item-step" }, [
              _vm._v("Step 2")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "c-report-progress__list-item-label" }, [
              _vm._v(_vm._s(_vm.stepTwoTitle))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "visually-hidden" }, [
              _vm._v(_vm._s(_vm.textState(2)))
            ]),
            _vm._v(" "),
            _vm.showTick(2)
              ? _c(
                  "svg",
                  {
                    staticClass: "c-report-progress__list-item-icon",
                    attrs: { "aria-hidden": "true", focusable: "false" }
                  },
                  [
                    _c("use", {
                      attrs: {
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xlink:href": "#tick"
                      }
                    })
                  ]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "c-report-progress__list-item c-report-progress__list-item--about-you",
            class: _vm.stepState(3)
          },
          [
            _c("span", { staticClass: "c-report-progress__list-item-step" }, [
              _vm._v("Step 3")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "c-report-progress__list-item-label" }, [
              _vm._v(_vm._s(_vm.stepThreeTitle))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "visually-hidden" }, [
              _vm._v(_vm._s(_vm.textState(3)))
            ]),
            _vm._v(" "),
            _vm.showTick(3)
              ? _c(
                  "svg",
                  {
                    staticClass: "c-report-progress__list-item-icon",
                    attrs: { "aria-hidden": "true", focusable: "false" }
                  },
                  [
                    _c("use", {
                      attrs: {
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xlink:href": "#tick"
                      }
                    })
                  ]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "c-report-progress__list-item c-report-progress__list-item--leave-it-with-us",
            class: _vm.stepState(4)
          },
          [
            _c("span", { staticClass: "c-report-progress__list-item-step" }, [
              _vm._v("Step 4")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "c-report-progress__list-item-label" }, [
              _vm._v(_vm._s(_vm.stepFourTitle))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "visually-hidden" }, [
              _vm._v(_vm._s(_vm.textState(4)))
            ]),
            _vm._v(" "),
            _vm.showTick(4)
              ? _c(
                  "svg",
                  {
                    staticClass: "c-report-progress__list-item-icon",
                    attrs: { "aria-hidden": "true", focusable: "false" }
                  },
                  [
                    _c("use", {
                      attrs: {
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xlink:href": "#tick"
                      }
                    })
                  ]
                )
              : _vm._e()
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec2e4b9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec2e4b9a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/report-a-problem/_vue/ProgressBar.vue
// module id = 693
// module chunks = 0